<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="CreateInvoice"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :color="$config.invoice.color"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
    @deleted="evh_2248226175642056_deleted($event, {})"
  >
    <UcInvoiceHeader
      :invoice="_.clone(item)"
      :formId="formId"
      :formContext="formContext"
      :invoiceNumber="registerEntry ? item.reference_number : null"
    >
    </UcInvoiceHeader>
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :id="formId"
      name="invoice"
      autofocus="first"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <FieldsetInvoiceHeader
        :formId="formId"
        :invoice="item"
        :labelAlign="labelAlign"
      >
      </FieldsetInvoiceHeader>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    :color="$config.invoice.color"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :form="forms.invoice && forms.invoice.id"
      icon="fa-save"
      :text="'Create invoice'|pgettext('CreateInvoice|Submit')"
      type="submit"
      variant="primary"
      :spinning="actions.submit.isRunning"
      :disabled="!forms.invoice || !forms.invoice.submittable"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|gettext"
      variant="default"
      :disabled="actions.submit.isRunning"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class CreateInvoice extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    type: String,
    default: "outgoing",
  })
  invoiceKind!: string;

  @Watch('invoiceKind')
  onInvoice_kind(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("invoiceKind")
  }

  @Prop({
    type: String,
    default: "normal",
  })
  invoiceType!: string;

  @Watch('invoiceType')
  onInvoice_type(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("invoiceType")
  }

  @Prop({
    type: String,
  })
  registerEntry!: string;

  @Watch('registerEntry')
  onRegister_entry(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("registerEntry")
  }

  @Prop({
    type: String,
    default: "lg",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  labelAlign!: any;
  titles!: any;
  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  item!: any;

  async $$load_item() {
    return this.$fn.fetch('get_invoice_template', {
      parameters: {
        invoice_kind: this.invoiceKind,
        invoice_type: this.invoiceType,
        register_entry: this.registerEntry
      }
    }).then(data => new this.$fn.Resource(data, {
      billing_period: data.billing_period || { start: null, end: null },
    })
    )
  }

  formContext!: any;
  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['labelAlign', 'titles', 'formId', 'item', 'formContext', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        labelAlign: "right",
        titles: {
          incoming: this.$fn.pgettext("Invoice", "Create Incoming Invoice"),
          outgoing: this.$fn.pgettext("Invoice", "Create Outgoing Invoice"),
        }
        ,
        formId: null,
        item: null,
        formContext: {
        }
        ,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "lg",
        }
        ,
      },
    }
  }

  get incomingInvoice() {
    if (this.loaded) {

      return this.invoiceKind === 'incoming'
    }
    return null;
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.titles[this.invoiceKind],
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_4348_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_4348, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_reloadSlickgrid_4354_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_2248226175642056_reloadSlickgrid_4354, alias=undefined
    return {
      grid: "invoices",
    }
  }

  async evh_2248226175642056_deleted(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_deleted.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_closeModal_4358_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1040167445267876_closeModal_4358, alias=undefined
    return {
      result: {
        close: true,
      }
      ,
    }
  }

  async act_1040167445267876_navigate_4360_getActionArgs($event: actions.ActionEvent): Promise<actions.NavigateActionArgs> {
    // parameterResolver name=act_1040167445267876_navigate_4360, alias=undefined
    return {
      location: {
        name: "app.invoice",
        params: {
          id: $event.data.id,
        }
        ,
      }
      ,
    }
  }

  async act_1040167445267876_crud_4356_getActionArgs($event: actions.ActionEvent): Promise<actions.CRUDActionArgs> {
    // parameterResolver name=act_1040167445267876_crud_4356, alias=submit
    return {
      objectType: "invoice",
      op: "upsert",
      data: this.item,
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async act_1419464017721962_closeModal_4362_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1419464017721962_closeModal_4362, alias=undefined
    return {
      result: {
        close: true,
      }
      ,
    }
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_4348: actions.CloseModalAction;
    evh_7315092382398562_close_4347: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeModal_4350: actions.CloseModalAction;
    evh_2248226175642056_close_4349: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_2248226175642056_closeModal_4352: actions.CloseModalAction;
    evh_2248226175642056_deleted_4351: actions.EventHandlerImpl;
    act_2248226175642056_reloadSlickgrid_4354: actions.ReloadSlickgridAction;
    evh_2248226175642056_deleted_4353: actions.EventHandlerImpl;
    evh_2248226175642056_deleted: actions.EventHandlerGroup;
    act_1040167445267876_closeModal_4358: actions.CloseModalAction;
    evh_1040167445267876_success_4357: actions.EventHandlerImpl;
    act_1040167445267876_navigate_4360: actions.NavigateAction;
    evh_1040167445267876_success_4359: actions.EventHandlerImpl;
    act_1040167445267876_crud_4356: actions.CRUDAction;
    evh_1040167445267876_submit_4355: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_1419464017721962_closeModal_4362: actions.CloseModalAction;
    evh_1419464017721962_clickPreventStop_4361: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_4348 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_4348_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_4347 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_4348,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_4347],
      }
    );
    const act_2248226175642056_closeModal_4350 = new actions.CloseModalAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_4349 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeModal_4350,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_4349],
      }
    );
    const act_2248226175642056_closeModal_4352 = new actions.CloseModalAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_deleted_4351 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeModal_4352,
        event: "deleted",
        displayName: "closeModal",
      }
    );
    const act_2248226175642056_reloadSlickgrid_4354 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_2248226175642056_reloadSlickgrid_4354_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_deleted_4353 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_reloadSlickgrid_4354,
        event: "deleted",
        displayName: "reloadSlickgrid",
      }
    );
    const evh_2248226175642056_deleted = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_deleted_4351, evh_2248226175642056_deleted_4353],
      }
    );
    const act_1040167445267876_closeModal_4358 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1040167445267876_closeModal_4358_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_4357 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeModal_4358,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_1040167445267876_navigate_4360 = new actions.NavigateAction(
      {
        actionArgs: this.act_1040167445267876_navigate_4360_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_4359 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_navigate_4360,
        event: "success",
        displayName: "navigate",
      }
    );
    const act_1040167445267876_crud_4356 = new actions.CRUDAction(
      {
        actionArgs: this.act_1040167445267876_crud_4356_getActionArgs,
        displayName: "submit",
        events: [evh_1040167445267876_success_4357, evh_1040167445267876_success_4359],
      }
    );
    const evh_1040167445267876_submit_4355 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_crud_4356,
        event: "submit",
        displayName: "submit",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_4355],
      }
    );
    const act_1419464017721962_closeModal_4362 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1419464017721962_closeModal_4362_getActionArgs,
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_4361 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeModal_4362,
        event: "click.prevent.stop",
        displayName: "closeModal",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_4361],
      }
    );
    return {
      act_7315092382398562_closeModal_4348,
      evh_7315092382398562_close_4347,
      evh_7315092382398562_close,
      act_2248226175642056_closeModal_4350,
      evh_2248226175642056_close_4349,
      evh_2248226175642056_close,
      act_2248226175642056_closeModal_4352,
      evh_2248226175642056_deleted_4351,
      act_2248226175642056_reloadSlickgrid_4354,
      evh_2248226175642056_deleted_4353,
      evh_2248226175642056_deleted,
      act_1040167445267876_closeModal_4358,
      evh_1040167445267876_success_4357,
      act_1040167445267876_navigate_4360,
      evh_1040167445267876_success_4359,
      act_1040167445267876_crud_4356,
      evh_1040167445267876_submit_4355,
      evh_1040167445267876_submit,
      act_1419464017721962_closeModal_4362,
      evh_1419464017721962_clickPreventStop_4361,
      evh_1419464017721962_clickPreventStop,
      submit: act_1040167445267876_crud_4356,
    }
  }
}

Vue.component("CreateInvoice", CreateInvoice);

</script>